module.exports = __webpack_public_path__ + "static/img/shanghai.20e793a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shanghai.png
// module id = rFNh
// module chunks = 1